import { render } from "./room-form.vue?vue&type=template&id=c964f1a6&scoped=true"
import script from "./room-form.vue?vue&type=script&lang=js"
export * from "./room-form.vue?vue&type=script&lang=js"

import "./room-form.vue?vue&type=style&index=0&id=c964f1a6&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c964f1a6"]])

export default __exports__